import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import 'src/index.css';
import { LocaleProvider } from 'src/contexts/LocaleContext';
import { ROUTES } from 'src/constants/routes';
import LandingPage from 'src/pages/LandingPage';
import BlogIndexPage from 'src/pages/blog/BlogIndexPage';
import BlogPostPage from 'src/pages/blog/BlogPostPage';

const ClinicApp = lazy(() => import('src/App'));

const toastOptions = {
  duration: 4000,
  style: {
    background: '#363636',
    color: '#fff',
  },
  success: {
    duration: 3000,
    theme: {
      primary: '#4ade80',
    },
  },
  error: {
    duration: 5000,
    theme: {
      primary: '#ef4444',
    },
  },
};

function AppShell() {
  return (
    <LocaleProvider>
      <BrowserRouter>
        <Routes>
          <Route path={ROUTES.home} element={<LandingPage />} />
          <Route path={ROUTES.blog} element={<BlogIndexPage />} />
          <Route path={ROUTES.blogPost} element={<BlogPostPage />} />
          <Route
            path={ROUTES.app}
            element={(
              <Suspense
                fallback={(
                  <div className="flex min-h-screen items-center justify-center">
                    <div className="h-32 w-32 animate-spin rounded-full border-b-2 border-[#7c3aed]" />
                  </div>
                )}
              >
                <ClinicApp />
              </Suspense>
            )}
          />
        </Routes>
        <Toaster position="top-right" toastOptions={toastOptions} />
      </BrowserRouter>
    </LocaleProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppShell />
  </React.StrictMode>
);
